import * as z from 'zod';

export const PaymentCustomerSchema = z.object({
    id: z.string(),
    token: z.string(),
});

export type PaymentCustomer = z.infer<typeof PaymentCustomerSchema>;
